import React, { useState, useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import Modal from '../Modal'
import toastr from 'toastr'
import ApiService from '../../data/services/ApiService'
import PaymentForm from '../../pages/pagos/PaymentForm'

const POLL_INTERVAL_MS = 3000
const POLL_MAX_ATTEMPTS = 20

const ExpiredPlanBanner = (props) => {
    const [showModal, setShowModal] = useState(false)
    const [plans, setPlans] = useState([])
    const [currentPlan, setCurrentPlan] = useState(null)
    const [polling, setPolling] = useState(false)

    const empresa = props.empresa || {}
    const hasEmpresa = Boolean(empresa._id)
    const cortesia = empresa.cortesia === true
    const activo = empresa.status === true
    const [purchasedBalance, setPurchasedBalance] = useState(null)

    // Paid activation is optional until the user needs to stamp; purchased credits also grant access.
    const shouldShow = hasEmpresa && purchasedBalance !== null && !cortesia && !activo && purchasedBalance === 0

    useEffect(() => {
        if (!hasEmpresa) {
            return
        }

        if (cortesia) {
            setPurchasedBalance(0)
            return
        }

        ApiService.getSubscriptionStatus()
            .then(res => setPurchasedBalance(Number(res.data?.data?.creditsAvailable || 0)))
            .catch(() => setPurchasedBalance(0))
    }, [cortesia, empresa._id, hasEmpresa])

    useEffect(() => {
        if (shouldShow && plans.length === 0) {
            ApiService.getPlans()
                .then(res => {
                    const fetchedPlans = res.data.plans || []
                    setPlans(fetchedPlans)
                    if (empresa.plan) {
                        const empresaPlanId = typeof empresa.plan === 'object' ? empresa.plan._id : empresa.plan
                        const found = fetchedPlans.find(p => p._id === empresaPlanId)
                        setCurrentPlan(found || null)
                    }
                })
                .catch(() => {})
        }
    }, [shouldShow])

    const pollUntilActive = useCallback(() => {
        setPolling(true)
        let attempts = 0
        const interval = setInterval(async () => {
            attempts += 1
            try {
                const res = await ApiService.getSubscriptionStatus()
                if (res.data?.data?.active) {
                    clearInterval(interval)
                    setPolling(false)
                    setShowModal(false)
                    toastr.success('¡Tu suscripción ha sido activada! Ya puedes timbrar facturas.')
                }
            } catch (_) {}
            if (attempts >= POLL_MAX_ATTEMPTS) {
                clearInterval(interval)
                setPolling(false)
                toastr.info('Tu pago está siendo procesado. Recibirás un correo cuando se confirme.')
            }
        }, POLL_INTERVAL_MS)
    }, [])

    const handleSuccess = () => {
        pollUntilActive()
    }

    if (!shouldShow) { return null }

    return (
        <>
            <div style={{
                background: '#fff3cd',
                borderBottom: '2px solid #ffc107',
                padding: '10px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 16,
                flexWrap: 'wrap'
            }}>
                <span style={{ fontWeight: 500, color: '#856404', fontSize: 14 }}>
                    {empresa.pagante
                        ? '⚠️ Tu suscripción no está activa. Actívala para volver a timbrar facturas.'
                        : 'Tu cuenta está lista. Activa un plan cuando quieras timbrar tu primera factura.'}
                </span>
                <button
                    onClick={() => setShowModal(true)}
                    style={{
                        background: '#c38000',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        padding: '6px 18px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        fontSize: 13,
                        whiteSpace: 'nowrap'
                    }}
                >
                    {empresa.pagante ? 'Reactivar plan' : 'Activar plan'}
                </button>
            </div>

            {showModal && (
                <Modal
                    isOpen={true}
                    onRequestClose={() => !polling && setShowModal(false)}
                    contentLabel="Renovar suscripción"
                    title={empresa.pagante ? 'Reactivar suscripción' : 'Activar plan'}
                    body={
                        polling ? (
                            <div style={{ textAlign: 'center', padding: '32px 0', color: '#888' }}>
                                <p>Esperando confirmación de pago...</p>
                                <p style={{ fontSize: 13 }}>Esto puede tardar unos momentos. No cierres esta ventana.</p>
                            </div>
                        ) : (
                            <PaymentForm
                                currentPlan={currentPlan}
                                plans={plans}
                                onSuccess={handleSuccess}
                            />
                        )
                    }
                />
            )}
        </>
    )
}

const mapStateToProps = (state) => {
    return { empresa: state.Auth.profile?.empresa || null }
}

export default connect(mapStateToProps, {})(ExpiredPlanBanner)
